import { SnackbarDataInterface } from './snackbar-data-interface';
import { ErrorInterface } from '../error/error-interface';

export class SnackbarData implements SnackbarDataInterface {
  private message: string;
  private error: ErrorInterface |null;

  constructor(message: string, error?: ErrorInterface) {
    this.message = message;
    this.error = error ?? null;
  }

  isSuccess(): boolean {
    // Implement your logic here
    return true;
  }

  getData(): any {
    // Implement your logic here
    return {};
  }

  setData(data: any): void {
    // Implement your logic here
  }

  getError(): ErrorInterface|null {
    return this.error;
  }

  setError(error: ErrorInterface): void {
    this.error = error;
  }

  getMessage(): string {
    return this.message;
  }
}
